(function () {
    'use strict';

    const modules = [
        // Never used directly only implicitly in the base angularjs library
        'ngAnimate',
        'ngMessages',
        'angularFileUpload',
        // Used filters
        // - unique (dop-search, justification-editor, CreateGovt, IssueClearanceWizard),
        // - range (pagination)
        'angular.filter',
        // Directive for selection using checkboxes
        'checklist-model',
        // Required when using ng-bind-html otherwise we need to explicitly use $sce.trustAsHtml
        'ngSanitize',
        'rx',
        // uiMask directive used for Kbo- and RR-, fodbzText and fodbzTextRequired inputs
        // Removes the "static mask" markup from the model in the case of KBO and RR numbers
        // For fodbzText the behaviour of the mask-directive is replicated using the model-view-value="true" option
        'ui.mask',
        // Used for inputs which allow multiple values (email addresses, nationalities, ...)
        'ngTagsInput',
    ];
    angular.module('app', modules)
        .run(['$rootScope', '$document', 'guid', function ($rootScope, $document, guid) {
            configureRootScope($rootScope, $document, guid);
        }])
        // Configure interceptors to detect
        // - Expired sessions (redirect to login)
        // - Append a cache busting GET parameter for component template files
        .config(['$httpProvider', function ($httpProvider) {
            $httpProvider.interceptors.push('unauthorizedAccess');
            $httpProvider.interceptors.push('sessionWatcher');
            $httpProvider.interceptors.push('templateResolver');
        }])
        .config(['$sanitizeProvider', function ($sanitizeProvider) {
            // Allow video and source elements
            $sanitizeProvider.addValidElements({
                htmlElements: ['video'],
                htmlVoidElements: ['source']
            });

            // This enables the 'style' attribute and allows controls for video elements
            $sanitizeProvider.addValidAttrs([
                'style', 'controls'
            ]);
        }])
        .config(['$locationProvider', function ($locationProvider) {
            $locationProvider.html5Mode(
                {
                    enabled: true,
                    requireBase: false,
                    rewriteLinks: false
                });
            }
        ]);

    function configureRootScope($rootScope, $document, guid) {

        $rootScope.emailLength = 254;

        $rootScope.ToggleShowHidePassword = toggle;
        function toggle(passwordField, showhideIcon) {
            const pwd = angular.element($document[0].querySelector('#' + passwordField));
            const showOrHideIcon = angular.element($document[0].querySelector('#' + showhideIcon));
            if (pwd.attr('type') === 'password') {
                showOrHideIcon.removeClass('fa fa-eye');
                showOrHideIcon.addClass('fa fa-eye-slash');
                pwd.attr('type', 'text');
            } else {
                showOrHideIcon.removeClass('fa fa-eye-slash');
                showOrHideIcon.addClass('fa fa-eye');
                pwd.attr('type', 'password');
            }
        }

        // Make guid properties available on rootScope in guid "namespace"
        Object.assign($rootScope, { guid: guid });
    }
})();
